
import z from 'zod';

export const phoneSchema = z.object({
  formatted: z.string().min(7).max(22)
})

